// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2wJB5","signatureButtonsRight":"ModalSign_signatureButtonsRight__37J-h"};